import { FeedbackMessageType } from '../../models/types';
import './styles/TopToastMessageStyle.css';
import { useEffect, useState } from 'react';

interface TopToastMessageProps {
  toastText: string;
  toastType: FeedbackMessageType;
  resetMessage(): void;
}
const TopToastMessage: React.FC<TopToastMessageProps> = ({
  toastText,
  toastType,
  resetMessage,
}) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (toastText !== '') {
      setShowToast(true);
    }
    const delayDebounceFn = setTimeout(async () => {
      setShowToast(false);
      resetMessage();
    }, 20000);

    return () => clearTimeout(delayDebounceFn);
  }, [toastText]);
  return (
    <div
      onClick={() => setShowToast(false)}
      className={`top-nav-toast-message-container ${toastType} ${
        !showToast ? 'collapsed' : ''
      }`}
    >
      <p className="top-nav-toast-message">{toastText}</p>
    </div>
  );
};

export { TopToastMessage };
